import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { url } from 'statics';
import { ErrorResponse } from 'types';

import { api } from 'utils';

const useWithdrawLDApprove = (): UseMutationResult<
  [],
  ErrorResponse,
  { id: string; data: { confirmed_amount: number } }
> => {
  return useMutation(({ id, data }) =>
    api.put(`${url.withdrawLDApprove}/${id}/approve`, data)
  );
};
export default useWithdrawLDApprove;
